import React, { useState, useEffect } from 'react';

// import { ListGrid } from './ListGrid';
import { useGetAll } from '../hooks/PartnersHook';
// import { DownloadExcel } from '../../../../../_mexablock/helpers';
import { shallowEqual, useSelector } from 'react-redux';
import { UserModel } from '../../../../modules/auth/models/UserModel';
import { RootState } from '../../../../../setup';
import {
  KTSVG,
  userHasRole,
  maskPhoneNumber,
  SimpleAlert,
  LoadingGrid,
} from '../../../../../_mexablock/helpers';
import { Filter } from '../_modals/Filter';
import { downloadPDF } from '../../../../service/reportes/Partners';
import { TableList } from '../../../../../_mexablock/helpers/components/TableList';
import { parseAxiosError } from '../../../../service/reportes/AccountStatment';

let fechaActual = new Date();
let fecha_inicio_init = new Date(
  fechaActual.getFullYear(),
  fechaActual.getMonth() - 1,
  1
);
let fecha_fin_init = new Date();

const View: React.FC = () => {
  // OBTIENE ROL USUARIO
  const user: UserModel = useSelector<RootState>(
    ({ auth }) => auth.user,
    shallowEqual
  ) as UserModel;
  const { roles: userRoles } = user;
  const showFilterCode = userHasRole(
    ['ADMIN_MEXABLOCK', 'ADMIN_PARTNER'],
    userRoles
  );
  const [loadingView, setloadingView] = useState(true);
  const [initFilterValues, setInitFilterValues] = useState({
    type_id: 0,
    init_date: new Date(fecha_inicio_init).toISOString().split('T')[0],
    end_date: new Date(fecha_fin_init).toISOString().split('T')[0],
    filter: 0,
  });
  const [reloadGrid, setReloadGrid] = useState(Math.random() * 40);
  const { data, loadingRequest } = useGetAll(reloadGrid, initFilterValues);
  const [loadingDownload, setloadingDownload] = useState(false);

  useEffect(() => {
    if (data.length) {
      setloadingDownload(false);
    } else {
      setloadingDownload(true);
    }
  }, [data]);

  useEffect(() => {
    if (loadingRequest > 0) {
      setloadingView(false);
    }
  }, [loadingRequest]);

  const handleFilter = (values: any) => {
    setInitFilterValues(values);
  };
  const handleFilterClean = () => {
    setInitFilterValues({
      type_id: 0,
      init_date: new Date(fecha_inicio_init).toISOString().split('T')[0],
      end_date: new Date(fecha_fin_init).toISOString().split('T')[0],
      filter: 0,
    });
  };

  const columns: any = [
    {
      id: 'nombre',
      name: <div className="fw-bolder text-muted me-5">Nombre</div>,
      selector: (row: any) => row.nombre,
      cell: (row: any) => row.nombre,
      sortable: true,
      width: '180px',
    },
    {
      id: 'codigo',
      name: <div className="fw-bolder text-muted me-5">Código</div>,
      selector: (row: any) => row.codigo,
      cell: (row: any) => (
        <span className="text-primary fw-bolder">{row.codigo}</span>
      ),
      sortable: true,
      width: '120px',
    },
    {
      id: 'tipo',
      name: <div className="fw-bolder text-muted me-5">Tipo</div>,
      selector: (row: any) => row.tipo,
      sortable: true,
      width: '150px',
    },
    {
      id: 'fecha',
      name: <div className="fw-bolder text-muted me-5">Fecha de creacion</div>,
      selector: (row: any) => row.fecha,
      sortable: true,
      width: '220px',
    },
    {
      id: 'usuario_creo',
      name: <div className="fw-bolder text-muted me-5">Usuario creador</div>,
      selector: (row: any) => row.usuario_creo,
      cell: (row: any) => row.usuario_creo,
      sortable: true,
      width: '150px',
    },
    {
      id: 'saldo_virtual',
      name: <div className="fw-bolder text-muted me-5">Saldo virtual</div>,
      selector: (row: any) => row.saldo_virtual,
      cell: (row: any) => row.saldo_virtual,
      sortable: true,
      width: '150px',
    },
    {
      id: 'active',
      name: <div className="fw-bolder text-muted me-5">Estatus</div>,
      selector: (row: any) => row.active,
      cell: (row: any) => (
        <span className="text-primary fw-bolder">{row.active}</span>
      ),
      sortable: true,
      width: '120px',
    },
  ];

  const handleDownloadPDF = () => {
    setloadingDownload(true);
    setTimeout(() => {
      downloadPDF(initFilterValues)
        .then(() => {
          setloadingDownload(false);
        })
        .catch(async (error) => {
          setloadingDownload(false);
          const message = await parseAxiosError(error);
          SimpleAlert(message, 4000, 'error');
        });
    }, 2000);
  };

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xl-12">
          <div className={`card card-xxl-stretch mb-5 mb-xl-12`}>
            <div className="card-header border-0 pt-5">
              <Filter
                initFilterValues={initFilterValues}
                onCleanFilter={handleFilterClean}
                onSearchFilter={handleFilter}
                showFilterCode={showFilterCode}
              />
              <div className="card-toolbar">
                <button
                  className="btn btn-sm btn-light-danger ms-5"
                  disabled={loadingDownload}
                  onClick={handleDownloadPDF}
                >
                  {loadingDownload && data.length ? (
                    <span
                      className="indicator-progress"
                      style={{ display: 'block' }}
                    >
                      Descargando...
                      <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>
                  ) : (
                    <>
                      <KTSVG
                        path="/media/icons/duotune/files/fil009.svg"
                        className="svg-icon-5 svg-icon-gray-500 me-1"
                      />
                      Descargar PDF
                    </>
                  )}
                </button>
              </div>
            </div>
            {loadingView ? (
              <LoadingGrid text="Cargando..."></LoadingGrid>
            ) : (
              <TableList data={data} columns={columns}></TableList>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export { View };
